import type { ColumnState, GridApi } from 'ag-grid-community'

import type {
  ColumnStateLike,
  SortModelEntry,
} from '@/components/lemmala-design-system/table/types'

export const getSortModelFromColumnState = <TRowData>(
  gridApi: GridApi<TRowData>,
): SortModelEntry[] => {
  const getColumnState = (gridApi as { getColumnState?: () => ColumnStateLike[] }).getColumnState
  const state = (getColumnState?.() || []) as ColumnStateLike[]
  return state
    .filter((s) => s.colId && (s.sort === 'asc' || s.sort === 'desc'))
    .map((s) => ({ colId: s.colId!, sort: s.sort as 'asc' | 'desc' }))
}

export const applySortModelViaColumnState = <TRowData>(
  gridApi: GridApi<TRowData>,
  sortModel: SortModelEntry[],
) => {
  const state = sortModel.map((s) => ({ colId: s.colId, sort: s.sort }))
  gridApi.applyColumnState({
    defaultState: { sort: null },
    state,
    applyOrder: false,
  })
}

/**
 * Get the current column state from the grid API.
 * Returns column visibility and order information.
 */
export const getColumnStateFromGrid = <TRowData>(gridApi: GridApi<TRowData>): ColumnState[] => {
  return gridApi.getColumnState()
}
